module.exports = __webpack_public_path__ + "img/download.05d6b37e.png";